"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("@aperza/fabric");
var jspdf_1 = require("@aperza/jspdf");
exports.JsPDF = jspdf_1.jsPDF;
var PdfEditorFabricUtil_1 = require("./PdfEditorFabricUtil");
/**
 * How this works
 * ---
 * Layers:
 * input pdf page
 * input pdf canvas
 * input fabric canvas
 * output pdf page
 *
 * Steps:
 * - get output dimensions based on input pdf dimensions (viewport)
 * -- this is currently upscaled to 2 to improve image quality since output is image and not SVG
 * - create new pdf page in output pdf document
 * - render input pdf page to pdf canvas
 * - render fabric/stamp data on fabric canvas
 * - draw fabric canvas on top of pdf canvas
 * - convert merged pdf canvas into jpg image
 * - add jpg image to output pdf page
 * - return output pdf
 */
exports.createPdf = function (pdfDoc, fabricDataMap, grayscale) { return __awaiter(void 0, void 0, void 0, function () {
    var exportPdf, pdfCanvas, pdfCanvasContext, fabricCanvas, fabricInstance, _loop_1, existingPagesIndex;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                pdfCanvas = document.createElement('canvas');
                pdfCanvasContext = pdfCanvas.getContext('2d');
                fabricCanvas = document.createElement('canvas');
                fabricInstance = new fabric_1.fabric.StaticCanvas(fabricCanvas);
                _loop_1 = function (existingPagesIndex) {
                    var pageNumber, page, fabricDataEntry, rotationAngle, viewport, exportPdfDimensions, orientation_1, renderContext, fabricMultiplier, pdfFabricImageCanvas, pdfFabricImageCanvasContext, imgPixels, y, x, i, avg, imageSource, imgPixels, y, x, i, avg, pageDataURL;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageNumber = fabricDataMap.existingPages[existingPagesIndex];
                                return [4 /*yield*/, pdfDoc.getPage(pageNumber)];
                            case 1:
                                page = _a.sent();
                                fabricDataEntry = fabricDataMap.fabricData[pageNumber - 1];
                                rotationAngle = (_b = (_a = fabricDataMap.rotationArray[pageNumber - 1]) !== null && _a !== void 0 ? _a : fabricDataEntry === null || fabricDataEntry === void 0 ? void 0 : fabricDataEntry.rotate) !== null && _b !== void 0 ? _b : page.rotate;
                                viewport = page.getViewport({ scale: 2, rotation: 0 });
                                if (viewport.width >= 4096 || viewport.height >= 4096) {
                                    // if it's greater than 4k, no need to increase
                                    viewport = page.getViewport({ scale: 1, rotation: 0 });
                                }
                                pdfCanvas.width = viewport.width;
                                pdfCanvas.height = viewport.height;
                                fabricInstance.setWidth(viewport.width);
                                fabricInstance.setHeight(viewport.height);
                                exportPdfDimensions = [viewport.width, viewport.height];
                                // - create new pdf page in output pdf document
                                if (exportPdf) {
                                    exportPdf.addPage(exportPdfDimensions); // sets focus to this new page
                                }
                                else {
                                    orientation_1 = viewport.width > viewport.height ? 'landscape' : 'portrait';
                                    exportPdf = new jspdf_1.jsPDF({ format: exportPdfDimensions, orientation: orientation_1, unit: 'pt' }); // due to a bug in JsPdf, the orientation for the first page must be set
                                }
                                if (!exportPdf) return [3 /*break*/, 5];
                                renderContext = {
                                    canvasContext: pdfCanvasContext,
                                    viewport: viewport,
                                };
                                // - render input pdf page to pdf canvas
                                return [4 /*yield*/, page.render(renderContext).promise];
                            case 2:
                                // - render input pdf page to pdf canvas
                                _a.sent();
                                if (!fabricDataEntry) return [3 /*break*/, 4];
                                // if that page has markup
                                return [4 /*yield*/, new Promise(function (resolve) { return fabricInstance.loadFromJSON(fabricDataEntry, resolve); })];
                            case 3:
                                // if that page has markup
                                _a.sent();
                                // remove shadows, kind of a work around to a fabric bug
                                fabricInstance.getObjects().forEach(function (object) {
                                    object.shadow = undefined;
                                });
                                // Old version (no fabricDataVersion) kept the objects in unrotated state.
                                PdfEditorFabricUtil_1.rotateObjectsByAngleDelta({
                                    fabricCanvas: fabricInstance,
                                    prevRotationAngle: fabricDataEntry.fabricDataVersion ? rotationAngle : 0,
                                    rotationAngle: 0,
                                    prevHeight: fabricDataEntry.dimensions.height,
                                    prevWidth: fabricDataEntry.dimensions.width,
                                    height: viewport.height,
                                    width: viewport.width,
                                    renderAll: true,
                                });
                                fabricMultiplier = 1.5;
                                pdfFabricImageCanvas = fabricInstance.toCanvasElement(fabricMultiplier);
                                pdfFabricImageCanvasContext = pdfFabricImageCanvas.getContext('2d');
                                if (grayscale) {
                                    imgPixels = pdfFabricImageCanvasContext.getImageData(0, 0, viewport.width * fabricMultiplier, viewport.height * fabricMultiplier);
                                    for (y = 0; y < imgPixels.height; y++) {
                                        for (x = 0; x < imgPixels.width; x++) {
                                            i = y * 4 * imgPixels.width + x * 4;
                                            avg = 0;
                                            if (imgPixels.data[i] !== 255 &&
                                                imgPixels.data[i + 1] !== 255 &&
                                                imgPixels.data[i + 2] !== 255) {
                                                imgPixels.data[i] = avg;
                                                imgPixels.data[i + 1] = avg;
                                                imgPixels.data[i + 2] = avg;
                                            }
                                        }
                                    }
                                    pdfFabricImageCanvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
                                }
                                // - draw fabric canvas on top of pdf canvas
                                pdfCanvasContext.drawImage(pdfFabricImageCanvas, 0, 0, viewport.width, viewport.height);
                                _a.label = 4;
                            case 4:
                                imageSource = pdfCanvas;
                                if (grayscale) {
                                    imgPixels = pdfCanvasContext.getImageData(0, 0, viewport.width, viewport.height);
                                    for (y = 0; y < imgPixels.height; y++) {
                                        for (x = 0; x < imgPixels.width; x++) {
                                            i = y * 4 * imgPixels.width + x * 4;
                                            avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                                            imgPixels.data[i] = avg;
                                            imgPixels.data[i + 1] = avg;
                                            imgPixels.data[i + 2] = avg;
                                        }
                                    }
                                    pdfCanvasContext.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
                                    pageDataURL = pdfCanvas.toDataURL('image/jpeg', 0.8);
                                    imageSource = pageDataURL;
                                }
                                // format options: 'JPEG' | 'PNG'
                                // input is an image element, dataurl, or canvas element
                                // - add jpg image to output pdf page
                                exportPdf.addImage(imageSource, 'JPEG', 0, 0, viewport.width, viewport.height, undefined, 3); // JPEG produces smaller download than PNG but quality is the same
                                pdfCanvasContext.clearRect(0, 0, viewport.width, viewport.height);
                                // setPageRotate is a custom method in @aperza/jspdf
                                // @ts-ignore
                                exportPdf.setPageRotate(rotationAngle);
                                _a.label = 5;
                            case 5: return [2 /*return*/];
                        }
                    });
                };
                existingPagesIndex = 0;
                _c.label = 1;
            case 1:
                if (!(existingPagesIndex < fabricDataMap.existingPages.length)) return [3 /*break*/, 4];
                return [5 /*yield**/, _loop_1(existingPagesIndex)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3:
                existingPagesIndex++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, exportPdf];
        }
    });
}); };
exports.downloadPdf = function (pdfDoc, fabricDataMap, filename) { return __awaiter(void 0, void 0, void 0, function () {
    var exportPdf;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.createPdf(pdfDoc, fabricDataMap)];
            case 1:
                exportPdf = _a.sent();
                return [2 /*return*/, exportPdf === null || exportPdf === void 0 ? void 0 : exportPdf.save(filename || 'download.pdf')];
        }
    });
}); };
//# sourceMappingURL=PdfExportUtil.js.map